import {Component, OnInit} from '@angular/core';
import {DocumentViewerPageComponent} from '../../shared/components/document-viewer-page/document-viewer-page.component';
import {LangService} from '../../core/services/lang.service';
import {ReservationService} from '../../core/api/reservation.service';
import {getAppSectionName, getAppSectionUrl} from '../../shared/models/reservation.model';

@Component({
  selector: 'others-1',
  templateUrl: './others-1.component.html',
  imports: [DocumentViewerPageComponent]
})
export class Others1Component implements OnInit {

  title: string = '';
  url: string = '';

  constructor(private reservationService: ReservationService, private langService: LangService) {
  }

  ngOnInit(): void {
    this.reservationService.getReservation().subscribe(reservation => {
      this.title = getAppSectionName(reservation, 0);
      this.url = getAppSectionUrl(reservation, 0);
    });
  }
}
